var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHungary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.8886C0.352063 12.622 0 14.4967 0 16.4538C0 18.411 0.352063 20.2858 0.995188 22.019L16 23.4103L31.0048 22.019C31.6479 20.2858 32 18.411 32 16.4538C32 14.4967 31.6479 12.622 31.0048 10.8886L16 9.49733L0.995188 10.8886Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.454102C9.12074 0.454102 3.25599 4.7961 0.995361 10.8889H31.005C28.7442 4.7961 22.8796 0.454102 16.0001 0.454102V0.454102Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.4541C22.8796 32.4541 28.7442 28.1121 31.005 22.0193H0.995361C3.25599 28.1121 9.12074 32.4541 16.0001 32.4541V32.4541Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungary);
export default __webpack_public_path__ + "static/media/hungary.844b53e8.svg";
export { ForwardRef as ReactComponent };